import { render, staticRenderFns } from "./customerRegister.vue?vue&type=template&id=7614d493&scoped=true"
import script from "./customerRegister.vue?vue&type=script&lang=js"
export * from "./customerRegister.vue?vue&type=script&lang=js"
import style0 from "./customerRegister.vue?vue&type=style&index=0&id=7614d493&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7614d493",
  null
  
)

export default component.exports